/*! @azure/msal-common v16.11.2 2026-07-15 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.11.2";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
